
import React, { useEffect, useState } from "react";
import {
  Percent,
  ShieldCheck,
  MapPin,
  PhoneCall,
  MessageCircle,
} from "lucide-react";

export default function TopBar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll, {
      passive: true,
    });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`
        fixed left-0 top-0 z-[1100] w-full
        border-b border-white/10
        bg-[#064E3B] text-white
        transition-transform duration-300 ease-out
        ${isScrolled ? "-translate-y-full" : "translate-y-0"}
      `}
    >
      <div className="mx-auto flex min-h-[38px] max-w-[1536px] items-center justify-between px-4 sm:px-6 lg:px-8">

        {/* DESKTOP LEFT */}
        <div className="hidden items-center gap-5 text-[11px] sm:flex">
          <div className="flex items-center gap-2">
            <Percent size={14} className="text-[#F5C76B]" />
            <span className="text-white/80">
              Affordable Dubai Hotels
            </span>
            <span className="font-semibold text-[#F5C76B]">
              Great Hotel Deals
            </span>
          </div>

          <span className="h-3.5 w-px bg-white/20" />

          <div className="flex items-center gap-2 text-white/80">
            <ShieldCheck size={14} className="text-[#F5C76B]" />
            <span>Secure Hotel Booking</span>
          </div>

          <span className="hidden h-3.5 w-px bg-white/20 xl:block" />

          <div className="hidden items-center gap-2 text-white/80 xl:flex">
            <MapPin size={14} className="text-[#F5C76B]" />
            <span>Discover Dubai</span>
          </div>
        </div>

        {/* DESKTOP RIGHT */}
        <div className="hidden items-center gap-5 text-[11px] lg:flex">
          <a
            href="tel:+97144473839"
            className="flex items-center gap-2 text-white/85 transition hover:text-[#F5C76B]"
          >
            <PhoneCall size={14} className="text-[#F5C76B]" />
            <span>+971 4 447 3839</span>
          </a>

          <span className="h-3.5 w-px bg-white/20" />

          <a
            href="https://wa.me/971502477593"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-white/85 transition hover:text-[#F5C76B]"
          >
            <MessageCircle size={14} className="text-[#F5C76B]" />
            <span>WhatsApp Us</span>
          </a>
        </div>

        {/* MOBILE */}
        <div className="flex w-full items-center justify-center gap-4 text-[11px] sm:hidden">
          <a
            href="tel:+97144473839"
            className="flex items-center gap-1.5 text-white/90"
          >
            <PhoneCall size={13} className="text-[#F5C76B]" />
            Call Us
          </a>

          <span className="h-3.5 w-px bg-white/20" />

          <span className="flex items-center gap-1.5">
            <ShieldCheck size={13} className="text-[#F5C76B]" />
            Secure Booking
          </span>

          <span className="h-3.5 w-px bg-white/20" />

          <a
            href="https://wa.me/971502477593"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 text-white/90"
          >
            <MessageCircle size={13} className="text-[#F5C76B]" />
            WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}
